function getApiBase() {
  let apiBase = import.meta.env.VITE_API_URL;
  if (!apiBase) {
    const host = window.location.hostname;
    if (host === 'strategy.eastgrinsteadac.co.uk') {
      apiBase = 'https://strategy.eastgrinsteadac.co.uk';
    } else {
      // Preview deployments (*.egac-strategy-hub.pages.dev) and any other host.
      // The *.workers.dev subdomain is disabled on this Cloudflare account, so
      // that URL returns a 1042 edge error. Route API calls to the production
      // worker route instead; its CORS config allows preview origins.
      apiBase = 'https://strategy.eastgrinsteadac.co.uk';
    }
  }
  return apiBase;
}

export async function apiCall(endpoint, options = {}) {
  const API_BASE = getApiBase();
  const token = localStorage.getItem('auth_token');

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    let errorMessage = 'Request failed';
    try {
      const error = await response.json();
      errorMessage = error.error || errorMessage;
    } catch {
      errorMessage = `${response.status} ${response.statusText}`;
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export async function uploadFile(category, file) {
  const API_BASE = getApiBase();
  const token = localStorage.getItem('auth_token');
  const formData = new FormData();
  formData.append('file', file);
  formData.append('category', category);

  const response = await fetch(`${API_BASE}/api/files/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Upload failed');
  }

  return response.json();
}

export async function downloadFile(fileId, filename = 'download') {
  const API_BASE = getApiBase();
  const token = localStorage.getItem('auth_token');

  try {
    const response = await fetch(`${API_BASE}/api/files/${fileId}/download`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Download failed');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw new Error(`Failed to download file: ${error.message}`);
  }
}
